import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

import { CarrierProductSummary } from './getCarrierProductByIdQuery';

const ENDPOINT = `${APIConfiguration.carrier}carriers/products`;

export const getCarrierProductsRequest = (): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getCarrierProductsQuery = async (): Promise<
  BackResponse<CarrierProductSummary[]> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<CarrierProductSummary[]>>(
      getCarrierProductsRequest(),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
